import type { FC } from 'react';
import { Flex } from '@chakra-ui/react';
import { useIntl } from 'react-intl';
import { useCustomerGeoLocationStore } from '../../../bff-api/stores/useCustomerGeoLocationStore';
import { Email } from '../email';
import { FindUs } from '../find-us';
import {
    StackedAboutLinks,
    StackedCustomerServiceLinks,
    StackedExperienceLinks,
} from '../link-groups';
import { Social } from '../social';
import { FooterStore } from '../store/FooterStore';

export const FooterTabletLarge: FC = () => {
    const { data } = useCustomerGeoLocationStore();
    const intl = useIntl();

    return (
        <div data-testid="footer-tablet-large-container" className="h-full w-full">
            <div className="flex justify-center">
                <div className="w-[42.5rem]">
                    <Email />
                </div>
            </div>
            <div className="mt-12 flex justify-between">
                <div className="flex-1">
                    <StackedExperienceLinks />
                </div>
                <div className="flex-1">
                    <StackedCustomerServiceLinks />
                </div>
                <div className="flex-1">
                    <StackedAboutLinks />
                </div>
                <div className="flex flex-1 flex-col">
                    <Flex direction="column" gap={5}>
                        <FooterStore
                            id="footer"
                            store={data}
                            title={intl
                                .formatMessage({
                                    id: 'nearest.store',
                                    defaultMessage: 'Nearest Store',
                                })
                                .toUpperCase()}
                        />
                        <FindUs />
                    </Flex>
                    <div className="mt-12 max-w-[352px]">
                        <Social />
                    </div>
                </div>
            </div>
        </div>
    );
};
